export const tableHelpers = {
    data() {
        return {
            tableColumns: [{
                    title: 'Ciudad',
                    type: 'custom-html',
                    key: 'canton',
                    modifier: (item) => {

                        if (item) {
                            return item.name;
                        }
                    }
                },
                {
                    title: 'Dirección',
                    type: 'text',
                    key: 'address',
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}